import { useState } from 'react';
import { useCustomerInfo } from '../../../hooks/useCustomerInfo';
import { useTranslations } from '../../../hooks/useTranslations';
import { useMarketInfo, formatPrice } from '../../../hooks/useMarketInfo';
import styles from './PriceDisplay.module.scss';

type BreakdownItem = {
  label: string;
  value: number | string;
};

type PriceDisplayProps = {
  price: number;
  breakdown: BreakdownItem[];
  isProvisional?: boolean;
};

const PriceDisplay = ({ price, breakdown, isProvisional = false }: PriceDisplayProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const customerInfo = useCustomerInfo();
  const t = useTranslations();
  const marketInfo = useMarketInfo();

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const formatValue = (value: number | string) => {
    if (typeof value === 'number') {
      return formatPrice(value, { showSymbol: true, showCurrency: true });
    }
    return value;
  };

  // 非ログインユーザーには価格を表示しない
  if (!customerInfo.isLoggedIn) {
    return (
      <div className={styles.priceDisplay}>
        <div className={styles.loginPrompt}>
          <div className={styles.promptIcon}>🔒</div>
          <div className={styles.promptContent}>
            <p className={styles.promptTitle}>{t.priceDisplay_loginPromptTitle}</p>
            <p className={styles.promptDescription}>
              {t.priceDisplay_loginPromptDescription}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.priceDisplay} ${isOpen ? styles.isOpen : ''}`}>
      {isOpen && (
        <div className={styles.accordionContent}>
          <ul className={styles.breakdownList}>
            {breakdown.map((item, index) => (
              <li key={index} className={styles.breakdownItem}>
                <span className={styles.breakdownLabel}>{item.label}</span>
                <span className={styles.breakdownValue}>{formatValue(item.value)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className={styles.totalSection}>
        <div className={styles.leftSection}>
          <span className={styles.totalLabel}>Total</span>
          <div className={styles.priceContainer}>
            <span className={styles.priceAmount}>
              {formatPrice(price, { showSymbol: false, showCurrency: false })}
              {isProvisional && '〜'}
            </span>
            <span className={styles.priceUnit}>{marketInfo.currency}</span>
          </div>
        </div>
        <button className={styles.rightSection} onClick={toggleAccordion}>
          <span className={styles.detailsLabel}>{t.priceDisplay_details}</span>
          <div className={`${styles.icon} ${isOpen ? styles.open : ''}`} />
        </button>
      </div>
    </div>
  );
};

export default PriceDisplay; 